import React from "react";
import "./ProjectAccess.css";
import { Button } from "reactstrap";

const ProjectAccessModal = ({ onClose, data, setData, user_id }) => {
  const handleCheckboxChange = (id, checked) => {
    setData((prevData) => {
      const updatedData = prevData.map((user) => {
        if (user?.user_id === user_id) {
          return {
            ...user,
            notification_accesses: user?.notification_accesses?.map(
              (notification) =>
                notification.id === id
                  ? { ...notification, isChecked: checked }
                  : notification
            ),
          };
        }
        return user;
      });
      return updatedData;
    });
  };

  const handleSave = () => {
    onClose();
  };

  // Find the user's data in the selectedData array
  const userData = data && data?.find((user) => user?.user_id === user_id);

  return (
    <>
      <div
        className="modal-backdrop"
        style={{
          background: "rgba(21, 2, 2, 0.5)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        }}>
        <div
          className="modal-container"
          style={{ padding: "15px", overflow: "visible" }}>
          <header className="modal-header">
            <h2>Notifications Access</h2>
            <button className="icon-button" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </header>

          <div className="modal-content">
            <div
              className="info-card"
              style={{
                maxHeight: "54vh",
                overflowY: "auto",
                scrollbarWidth: "thin",
                scrollBehavior: "smooth",
              }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {userData &&
                    userData?.notification_accesses &&
                    userData?.notification_accesses?.map((item) => (
                      <tr key={item?.id}>
                        <td>{item?.name}</td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={item.isChecked}
                              onChange={(e) =>
                                handleCheckboxChange(item.id, e.target.checked)
                              }
                              style={{ width: "32px", height: "18px" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div
            className="justify-content-center"
            style={{ marginTop: "-15px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}>
              <Button color="primary" onClick={handleSave}>
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProjectAccessModal;
